const state = {
  list: []
};

const getters = {
};

const actions = {
};

const mutations = {
  setOrganisations: (state, data) => (state.list = data),
  setOrganisation: (state, data, index) => (state.list[index] = data)
};

export default {
  state,
  getters,
  actions,
  mutations
};
